import { toast } from 'sonner';
import { useUser } from '../contexts/user-context/use-user';
import { CompanyView } from '../types/entity-types';

export const useCompanyAPI = () => {
  const { authenticatedFetch } = useUser();

  const searchCompanies = async (query: string, country = 'IE'): Promise<CompanyView[]> => {
    if (query.length <= 2) return [];

    try {
      const response = await authenticatedFetch(
        `/api/register/companies?country=${country}&q=${encodeURIComponent(query)}`,
      );
      if (response.ok) {
        return await response.json();
      } else {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Error searching companies');
      }
    } catch {
      toast.error('There was a problem searching companies');
      return [];
    }
  };

  const createCompany = async (
    companyData: Partial<CompanyView>,
    termsAndConditionsId: string,
  ): Promise<CompanyView> => {
    try {
      const response = await authenticatedFetch('/api/companies', {
        method: 'POST',
        body: JSON.stringify({ ...companyData, termsAndConditionsId }),
      });

      if (response.ok) {
        return await response.json();
      } else {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Error creating company');
      }
    } catch (error) {
      toast.error('There was a problem creating the company');
      throw error;
    }
  };

  return {
    searchCompanies,
    createCompany,
  };
};
